// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC0cj2BKbaUsCo2gpCSb3kaNqYW1msYaj8",
  authDomain: "pixellab-drip-landing-page.firebaseapp.com",
  projectId: "pixellab-drip-landing-page",
  storageBucket: "pixellab-drip-landing-page.appspot.com",
  messagingSenderId: "618131712890",
  appId: "1:618131712890:web:029588c4a66628982a44c3",
  measurementId: "G-BZKYMLJ3RS",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default analytics;
